// /src/components/Nav.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, Wrench, Code, User, Calendar, BookOpen, Menu, X, Sun, Moon } from 'lucide-react';
import LogoDL from '../assets/DL.png';

export default function Nav({ isDark, setIsDark }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: '/', label: 'Home', icon: Home },
    { to: '/about', label: 'About', icon: User },
    { to: '/tools', label: 'Platforms', icon: Wrench },
    { to: '/open-source', label: 'Open Source', icon: Code },
    { to: '/playbooks', label: 'Playbooks', icon: BookOpen },
    { to: '/blog', label: 'Blog', icon: FileText },
    { to: '/contact', label: 'Book Me', icon: Calendar }
  ];

  return (
    <nav className="sticky top-0 z-50 border-b border-[color:var(--border)]" style={{ background: 'var(--card)' }}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2 hover:opacity-90 transition">
            <img
              src={LogoDL}
              alt="Domenic Laurenzi Logo"
              className="w-8 h-8 rounded-full object-cover"
            />
            <span className="font-mono text-sm font-semibold">Domenic Laurenzi</span>
          </Link>

          <div className="hidden md:flex items-center gap-2">
            {links.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition ${
                  location.pathname === to
                    ? 'bg-[var(--accent)] text-white'
                    : 'hover:bg-[var(--bg2)]'
                }`}
              >
                <Icon size={18} />
                {label}
              </Link>
            ))}

            <button
              onClick={() => setIsDark(!isDark)}
              className="p-2 rounded-lg hover:bg-[var(--bg2)] transition ml-2"
              aria-label="Toggle theme"
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
            </button>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 rounded-lg hover:bg-[var(--bg2)] transition"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden py-4 space-y-2">
            {links.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-2 px-4 py-3 rounded-lg transition ${
                  location.pathname === to
                    ? 'bg-[var(--accent)] text-white'
                    : 'hover:bg-[var(--bg2)]'
                }`}
              >
                <Icon size={18} />
                {label}
              </Link>
            ))}

            <button
              onClick={() => {
                setIsDark(!isDark);
                setOpen(false);
              }}
              className="w-full flex items-center gap-2 px-4 py-3 rounded-lg hover:bg-[var(--bg2)] transition"
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
              {isDark ? 'Light Mode' : 'Dark Mode'}
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}